// Externe Bibliotheken
import React from 'react';

// Interne Module
import * as storage from '@/_helper/storage';

export const AppContext = React.createContext(null);
export const AppProvider = ({ children }) => {
    const [bookingData, setBookingData] = React.useState(storage.get('bookingData'));
    const [travelType] = React.useState(
        bookingData?.data?.frontendParams?.cruise ? 'cruise' : bookingData?.data.travelType
    );

    const constants = {
        MY_TRIP: travelType === 'cruise' ? 'Meine Kreuzfahrt' : 'Meine Reise',
        BACK_TO_MY_TRIP: travelType === 'cruise' ? 'Zurück zu meiner Kreuzfahrt' : 'Zurück zu meiner Reise',
    };

    return (
        <AppContext.Provider value={{ bookingData, setBookingData, constants, travelType }}>
            {children}
        </AppContext.Provider>
    );
};
